import { createSlice } from '@reduxjs/toolkit';

import type {
  RarDataAPIPagination,
  RarDataAPIReviewItem,
} from 'src/services/rar-data-api/types/RarDataAPIReviews';
import { logger } from 'src/utils/serverLogger';
import { requestProductReviews } from './thunks';

export type ReviewsPages = Record<number, RarDataAPIReviewItem[]> | null;

export interface ProductReviewsState {
  error: boolean;
  pages: ReviewsPages;
  pagination: RarDataAPIPagination | null;
}

export const initialState: Readonly<ProductReviewsState> = {
  error: false,
  pages: null,
  pagination: null,
};

export const { actions, reducer } = createSlice({
  name: 'reviews',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(requestProductReviews.fulfilled, (state, { payload }) => {
        const { pagination, reviews } = payload;
        state.pages = { ...(state.pages || {}), [pagination.currentPage]: reviews };
        state.pagination = { ...state.pagination, ...pagination };
      })
      .addCase(requestProductReviews.rejected, (state, action) => {
        logger.error('Error requesting product reviews', action.error);
        state.pages = { ...(state.pages || {}) };
        state.error = true;
      });
  },
});
